











































import Vue from 'vue'
import { Component } from 'vue-property-decorator'
import Box from '../components/Box.vue'
import api from "../../api/index"
import { Action } from 'vuex-class'


@Component({
  components: {
    'box': Box
  }
})

export default class NewPassword extends Vue {
  email = ""
  password = ""
  newPassword = ""
  newPasswordConfirm = ""
  passwordWasChanged = false

  @Action('createSession') createSession:any

  get formIsValid() {
    if (this.newPassword && this.newPasswordConfirm && this.newPassword === this.newPasswordConfirm) {
      return true
    } else {
      return false
    }
  }

  async mounted() {
    await api.init()
  }

  async changePassword() {
    if (this.formIsValid) {
      const params = {
        reset_password_token: this.$route.params.resetPasswordToken,
        email: this.$route.query.email,
        new_password: this.newPassword,
      }
      try {
        const res = await api.put("bo/password", params)
        this.passwordWasChanged = true
        await this.logIn()

        this.$router.push({ name: 'sites' })
      } catch (e) {

      }
    }
  }

  async logIn() {
    const params = {
      grant_type: "password",
      username: this.$route.query.email,
      password: this.newPassword,
    }
    try {
      const res = await api.post("oauth/token", params)
      this.createSession(res.data.access_token)
      this.$router.push({name: "sites"})
    } catch (e) {
      if (e.response.status === 401) {
        console.log(e.response.status)
      }
    }
  }
}
